import { Box, Typography } from "@mui/material";

const DeprecatedPage = () => {
  return (
    <Box sx={{ backgroundColor: "white", width: "max-content", p: 4 }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        This page is no longer active 😔
      </Typography>

      <Typography gutterBottom>
        We've deprecated this experience and it's no longer available for use.
      </Typography>
    </Box>
  );
};
export default DeprecatedPage;
